module.exports = __webpack_public_path__ + "static/media/newlszp.cc2231f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newlszp.mp4
// module id = v0zn
// module chunks = 1